module.exports = __webpack_public_path__ + "img/Tom Zhao.96bffd75.jpg";